var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.2 0c0.9 0.2 1.5 0.3 2.5 1.3l49.3 52.3c2.7 3-1.5 9.1-5.5 5.1l-49.3-52.3c-1.3-1.5-1.1-2-1.1-2.8 0-2.1 1.4-3.7 3.9-3.6 0.1 0 0.2 0 0.3 0Z","key":0}),React.createElement("path",{"d":"M53.5 0c1.9 0.2 2 0.7 2.5 1.2 1.3 1.4 1.5 3.4 0 5.1l-49.5 52.5c-1.3 1.3-1.8 1.1-2.5 1.2 -2.9 0.2-5.2-3.8-3-6.3l49.5-52.5c1.2-1.2 1.7-1.2 3.1-1.2Z","key":1})]);
}

X.defaultProps = {"width":"57","height":"60","viewBox":"0 0 57 60","strokeLinejoin":"round"};

module.exports = X;

X.default = X;
